import * as request from '../../../utils/request'

export function getLoginShop(param) {
    return request.post('os.myshop.shop.getLoginShop', '1.0.0.0', param)
}

export function list(param) {
    return request.post('os.myshop.shop.list', '1.0.0.0', param)
}

export function searchShopIdcard(param) {
    return request.post('os.myshop.shop.searchShopIdcard', '1.0.0.0', param)
}

export function getShopIdcard(param) {
    return request.post('os.myshop.shop.getShopIdcard', '1.0.0.0', param)
}

export function createShopIdcard(param) {
    return request.post('os.myshop.shop.createShopIdcard', '1.0.0.0', param)
}

export function updateShopIdcard(param) {
    return request.post('os.myshop.shop.updateShopIdcard', '1.0.0.0', param)
}

export function deleteShopIdcard(param) {
    return request.post('os.myshop.shop.deleteShopIdcard', '1.0.0.0', param)
}

export function getShopDesk(param) {
    return request.post('os.myshop.shop.getShopDesk', '1.0.0.0', param)
}

export function searchShopDesk(param) {
    return request.post('os.myshop.shop.searchShopDesk', '1.0.0.0', param)
}

export function createShopDesk(param) {
    return request.post('os.myshop.shop.createShopDesk', '1.0.0.0', param)
}

export function updateShopDesk(param) {
    return request.post('os.myshop.shop.updateShopDesk', '1.0.0.0', param)
}

export function deleteShopDesk(param) {
    return request.post('os.myshop.shop.deleteShopDesk', '1.0.0.0', param)
}

export function searchShopPos(param) {
    return request.post('os.myshop.shop.searchShopPos', '1.0.0.0', param)
}

export function getShopPos(param) {
    return request.post('os.myshop.shop.getShopPos', '1.0.0.0', param)
}

export function createShopPos(param) {
    return request.post('os.myshop.shop.createShopPos', '1.0.0.0', param)
}

export function updateShopPos(param) {
    return request.post('os.myshop.shop.updateShopPos', '1.0.0.0', param)
}

export function deleteShopPos(param) {
    return request.post('os.myshop.shop.deleteShopPos', '1.0.0.0', param)
}

export function bindShopPosPromoter(param) {
    return request.post('os.myshop.shop.bindShopPosPromoter', '1.0.0.0', param)
}
